import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Vintage.css';

const Vintage = () => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState('all');

  const products = [
    {
      id: 1,
      name: 'carhartt j97 detroit 2005',
      price: '$8000',
      material: 'detroit jacket',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/mos.jpg',
      slug: 'carhartt-j97-detroit-2005',
      type: 'outerwear'
    },
    {
      id: 2,
      name: 'carhartt j160 active jacket 2006',
      price: '$3500',
      material: 'active jacket',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/gris.jpg',
      slug: 'carhartt-j160-active-2006',
      type: 'outerwear'
    },
    {
      id: 3,
      name: 'carhartt santa fe aztec 1993',
      price: '$5000',
      material: 'santa fe jacket',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/morada.jpg',
      slug: 'carhartt-santa-fe-aztec-1993',
      type: 'outerwear'
    },
    {
      id: 4,
      name: 'carhartt BRK santa fe 1999',
      price: '$6000',
      material: 'santa fe jacket',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/roja.jpg',
      slug: 'carhartt-brk-santa-fe-1999',
      type: 'outerwear'
    },
    {
      id: 5,
      name: 'carhartt Chore Jacket 2010s',
      price: '$1000',
      material: 'chore jacket',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/chore.jpg',
      slug: 'carhartt-chore-jacket-2010s',
      type: 'outerwear'
    },
    {
      id: 6,
      name: 'santa fe j102 mos 2000',
      price: '$4500',
      material: 'santa fe jacket',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/green.jpg',
      slug: 'santa-fe-j102-mos-2000',
      type: 'outerwear'
    },
    {
      id: 7,
      name: 'carhartt j130 active jacket 2010',
      price: '$3000',
      material: 'active jacket',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/brown.jpg',
      slug: 'carhartt-j130-active-2010',
      type: 'outerwear'
    },
    {
      id: 8,
      name: 'Choppers jacket 2000s',
      price: '$3500',
      material: 'vintage jacket',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/choppers.jpg',
      slug: 'choppers-jacket-2000s',
      type: 'outerwear'
    },
    {
      id: 9,
      name: 'carhartt aztec jacket 1992',
      price: '$5500',
      material: 'aztec jacket',
      image: 'https://pruebasventaenlinea.s3.us-east-2.amazonaws.com/aztec.jpg',
      slug: 'carhartt-aztec-jacket-1992',
      type: 'outerwear'
    }
  ];

  const filteredProducts = selectedFilter === 'all'
    ? products
    : products.filter(p => p.type === selectedFilter);

  const handleFilterSelect = (filter) => {
    setSelectedFilter(filter);
    setIsFilterOpen(false);
  };

  return (
    <div className="vintage">
      <div className="vintage__container">
        <div className="vintage__header">
          <Link to="/home" className="vintage__back">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </Link>

          <div className="vintage__filter">
            <button
              className="vintage__filter-btn"
              onClick={() => setIsFilterOpen(!isFilterOpen)}
            >
              type
            </button>
            {isFilterOpen && (
              <div className="vintage__filter-dropdown">
                <button
                  className={`vintage__filter-option ${selectedFilter === 'all' ? 'active' : ''}`}
                  onClick={() => handleFilterSelect('all')}
                >
                  all
                </button>
                <button
                  className={`vintage__filter-option ${selectedFilter === 'outerwear' ? 'active' : ''}`}
                  onClick={() => handleFilterSelect('outerwear')}
                >
                  outerwear
                </button>
                <button
                  className={`vintage__filter-option ${selectedFilter === 'bottoms' ? 'active' : ''}`}
                  onClick={() => handleFilterSelect('bottoms')}
                >
                  bottoms
                </button>
                <button
                  className={`vintage__filter-option ${selectedFilter === 'footwear' ? 'active' : ''}`}
                  onClick={() => handleFilterSelect('footwear')}
                >
                  footwear
                </button>
              </div>
            )}
          </div>
        </div>

        <div className="vintage__grid">
          {filteredProducts.map((product) => (
            <Link
              key={product.id}
              to={`/products/${product.slug}`}
              className="product"
            >
              <div className="product__image">
                <img
                  src={product.image}
                  alt={product.name}
                  loading="lazy"
                />
              </div>
              <div className="product__info">
                <h2 className="product__name">{product.name}</h2>
                <p className="product__price">{product.price}</p>
                <p className="product__material">{product.material}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Vintage;
